import { ResponsiveCommandSelect, SelectOption } from "../responsive-select";

interface EntryTypeSelectProps {
  value: string;
  onValueChange: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
  error?: boolean;
  required?: boolean;
}

const ENTRY_TYPE_OPTIONS: SelectOption[] = [
  { value: "billable", label: "Billable" },
  { value: "non_billable", label: "Non-billable" },
  { value: "travel", label: "Travel" },
  { value: "research", label: "Research" },
];

export function EntryTypeSelect({
  value,
  onValueChange,
  placeholder = "Select entry type...",
  disabled = false,
  error = false,
  required = false,
}: EntryTypeSelectProps) {
  return (
    <ResponsiveCommandSelect
      value={value}
      onValueChange={onValueChange}
      options={ENTRY_TYPE_OPTIONS}
      placeholder={placeholder}
      disabled={disabled}
      title="Entry Type"
      description="Select the type of time entry"
    />
  );
}
